import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./DeleteChatModal.scss";

// Deleting a conversation removes every message in it (the API cascades) and
// there is no undo, so it is confirmed rather than immediate. This replaces a
// window.confirm - a browser dialog is jarring inside an app that has its own
// modal language, and it cannot carry the conversation's title clearly.
const DeleteChatModal = ({ show, title, onCancel, onConfirm, deleting }) => (
  <Modal
    show={show}
    onHide={deleting ? undefined : onCancel}
    centered
    backdrop={deleting ? "static" : true}
    dialogClassName="delete-chat-modal"
    aria-labelledby="delete-chat-title"
  >
    <Modal.Body className="delete-chat-body">
      <h3 id="delete-chat-title" className="delete-chat-title">
        Delete this chat?
      </h3>
      <p className="delete-chat-text">
        {title ? (
          <>
            &ldquo;<span className="delete-chat-name">{title}</span>&rdquo; and
            everything in it will be removed. This cannot be undone.
          </>
        ) : (
          <>This chat and everything in it will be removed. This cannot be undone.</>
        )}
      </p>
      <div className="delete-chat-actions">
        <Button
          variant="link"
          className="delete-chat-cancel"
          onClick={onCancel}
          disabled={deleting}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          className="delete-chat-confirm"
          onClick={onConfirm}
          disabled={deleting}
        >
          {deleting ? "Deleting..." : "Delete"}
        </Button>
      </div>
    </Modal.Body>
  </Modal>
);

export default DeleteChatModal;
